export const ORDER_CONTACTS_ADD_BUTTON =
  'orderContacts.order_contacts_add_button';
export const ORDER_CONTACTS_CART_EMAIL_LABEL =
  'order.contacts.cart.email.lable';
export const ORDER_CONTACTS_WORK_PHONE = 'order.contacts.work_phone';
export const ORDER_CONTACTS_HOME_PHONE = 'order.contacts.phone';
export const ORDER_CONTACTS_EMAIL_LABEL = 'order.contacts.email.label';
export const ORDER_CONTACTS_CELL_PHONE = 'order.contacts.cell_phone';
export const ORDER_CONTACTS_HEADER = 'order.contacts.header';
